import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const soundTitleImporterSelectors = importerSelectors(
  'soundTitle.importer',
);

export default soundTitleImporterSelectors;
